export const ReservationStatus = {
  PENDING: '예약 대기',
  COMPLETED: '예약 확정',
  REFUND_PENDING: '취소 대기',
  CANCELLED: '취소 완료',
  REFUND_COMPLETED: '환불 완료',
} as const;
